<template>
    <div v-if="showModal" class="modal-container">
      <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>

    <div class="modal-content w-[550px] relative bg-white m-auto flex-col flex rounded-lg z-50">
        <div  class="w-full border-b-[1px] mb-4 px-6 py-4">
          <p class="text-[18px] text-grayDark font-bold">{{ modalTitle }} {{ projectName }}</p>        
        </div>
        <ErrorMessage v-if="showError" :message="errorMessage" :duration="5000"/>

        <form @submit.prevent="submitModal" class="overflow-y-auto px-6 ">
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-grayDark">Email Address</label>
            <input 
              v-model="email"
              type="email" 
              placeholder="Enter manager email address..."
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            />
          </div>
        
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-grayDark">Manager Type</label>
            <select 
              v-model="managerType" 
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" 
              required
            >
              <option value="">Select type</option>
              <option value="manager">Manager</option>
              <option value="mentor">Mentor</option>
            </select>
          </div>

          <div class="flex justify-end mb-4 text-[14px]">
            <button type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" @click="$emit('close')">Cancel</button>
            <button 
              type="submit" 
              class="flex items-center gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded"
              :disabled="loading"
            >
              Add Manager
            </button>
          </div>
        </form>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios';
import ErrorMessage from '../messages/ErrorMessage.vue';

export default {
  name: 'AddProjectManagerModal',
  components: {
    ErrorMessage
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    projectName: {
      type: String,
      required: false,
      default: '',
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      managerType: '',
      modalTitle: 'Add Manager to',
      showError: false,
      errorMessage: '',
      loading: false,
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.email = '';
        this.managerType = '';
        this.showError = false;
        this.errorMessage = '';
      }
    }
  },
  methods: {
    async submitModal() {
      this.loading = true;
      this.showError = false;
      this.errorMessage = '';
      
      if (!this.email || !this.managerType) {
        this.showError = true;
        this.errorMessage = 'Email and Manager Type are required.';
        this.loading = false;
        return; 
      }

      const managerData = {
        email: this.email,
        manager_type: this.managerType,
      };

      try {
        const endpoint = `/web/projects/${this.projectId}/project_managers/`;
        const response = await apiClient.post(endpoint, managerData);
        
        this.$emit('manager-added', response.data.message || 'Manager added successfully!');
        this.$emit('close');
      } catch (error) {
        this.showError = true;
        this.errorMessage = error.response?.data?.message || 'Failed to add manager. Please try again.';
        console.error('Error adding project manager:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>
